import LoadingScreen from 'src/minimals/LoadingScreen';
import { useSelector } from 'react-redux';
import { useLocation, Navigate } from 'react-router';
import { PATH_AUTH, PATH_PAGE } from 'src/routes/paths';
import { userSelectors, workspaceSelectors, uiSelectors } from 'src/selectors';

export default function CustomerGuard({ children }) {
  const isAuthenticated = useSelector(userSelectors.isAuth());
  const location = useLocation();
  const isLoggedAsCustomer = useSelector(uiSelectors.isLoggedAsCustomer);
  const isWorkspaceLoading = useSelector(
    workspaceSelectors.isWorkspaceLoading()
  );

  if (!isAuthenticated) {
    return <Navigate to={PATH_AUTH.root} />;
  }

  if (isWorkspaceLoading) {
    return <LoadingScreen />;
  }

  const isCustomerPath =
    location.pathname === '/customer' ||
    location.pathname.startsWith('/customer/');

  if (isLoggedAsCustomer && !isCustomerPath) {
    return <Navigate to={PATH_PAGE.customer} />;
  }

  return <>{children}</>;
}
